import { Directive, ElementRef, Input, OnChanges, Renderer2 } from '@angular/core';

import { CopyService } from './copy.service';

@Directive({
  selector: '[dsContent]',
  standalone: false
})
export class ContentDirective implements OnChanges {
  @Input()
  contentPath: string;

  @Input()
  options: Parameters<CopyService['getCopy']>[1]; // Object containing keys for interpolation

  @Input()
  applicationDependentCopy?: boolean;

  constructor(
    private renderer: Renderer2,
    private element: ElementRef,
    private copyService: CopyService
  ) {}

  ngOnChanges() {
    const content = this.contentPath
      ? this.copyService.getCopy(this.contentPath, this.options, !!this.applicationDependentCopy)
      : '';
    this.renderer.setProperty(this.element.nativeElement, 'innerHTML', content);
  }
}
